import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Flex, Header } from "@fluentui/react-northstar";
import styles from "./emptyContent.module.scss";
import { ReactComponent as MsTeamsWelcome } from "shared/svgs/MsTeamsWelcome.svg";
import { ReactComponent as MsTeamsEmpty } from "../../../shared/svgs/MsTeamsEmpty.svg";

export interface EmptyContentProps {
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>
    graphic: "welcome" | "empty";
    message: string | undefined;
}

const EmptyContent: React.FC<EmptyContentProps> = observer((props)  => {

    useEffect(() => {
        if (props.setLoading === undefined) {
            return;
        }

        const initialize = async () => {
            props.setLoading!(true);
        };

        initialize();
    }, []);

    return (
        <Flex className={styles.wrapper} hAlign="center" vAlign="center" column>
            <div className={styles.svg}>
                {props.graphic === "welcome" && <MsTeamsWelcome />}
                {props.graphic === "empty" && <MsTeamsEmpty />}
            </div>
            <Header as="h2" content={props.message} align="center" />
        </Flex>
    )
});

export default EmptyContent;